import { useCallback } from 'react';
import { useNavigate, useSearchParams, NavigateOptions, To } from 'react-router-dom';

export const useNavigateWithCompany = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const navigateWithCompany = useCallback(
    (to: To, options?: NavigateOptions) => {
      const currentCompanyId = searchParams.get('companyId');

      if (!currentCompanyId) {
        navigate(to, options);
        return;
      }

      if (typeof to === 'string') {
        const url = new URL(to, window.location.origin);
        url.searchParams.set('companyId', currentCompanyId);
        navigate(url.pathname + url.search + url.hash, options);
        return;
      }

      const params = new URLSearchParams(to.search ?? '');
      params.set('companyId', currentCompanyId);
      const search = params.toString();
      navigate(
        {
          ...to,
          search: search ? `?${search}` : '',
        },
        options,
      );
    },
    [navigate, searchParams],
  );

  return navigateWithCompany;
};
